import { render } from "./VsAlert.vue?vue&type=template&id=a7b0a8ce"
import script from "./VsAlert.vue?vue&type=script&lang=js"
export * from "./VsAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__